export default {
  en: {
    community: 'Community',
    communities: 'Communities',
    noCommunities: 'No communities exist',
    noSelection: 'No community selected',
    members: 'Members',
    events: 'Events',
    created: 'Created',
    lastModified: 'Last modified',
    communityManager: 'Community manager',
    none: 'None',
    infoVideo: 'Info video',
    added: 'Added',
    updateCommunityStatus: {
      success: 'Community status updated',
      error: 'Failed to update community status',
      activate: 'Switch to active',
      deactivate: 'Switch to inactive',
    },
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    createCommunity: {
      button: 'Create community',
      success: 'Community created',
      error: 'Failed to create community',
      name: 'Community name',
      description: 'Community description',
      managerName: 'Community manager name',
      managerAvatarURL: 'Community manager photo URL',
      infoVideoURL: 'Community info video URL',
      namePlaceholder: 'e.g. public sector',
      descriptionPlaceholder: 'e.g. public sector description',
      preview: 'Preview',
      createNameGuidance:
        "Pick a name that clearly conveys the purpose of your community. This will help invitees understand the group's focus and decide if they want to join. The name should reflect the shared interests or goals of the members, such as 'UK water' for water industry professionals in the UK.",
      createDescriptionGuidance:
        'Set a description that will be helpful for members to understand why the community exists, what types of organisations might be part of it now and in the future, and what the benefits of joining the community are. e.g. "A community bringing together UK water companies, their regulators and suppliers."',
    },
    updateCommunity: {
      button: 'Edit community',
      success: 'Community updated',
      error: 'Failed to update community',
    },
    deleteCommunity: {
      success: 'Community deleted',
      error: 'Failed to delete community',
      button: 'Delete community',
      confirmTitle: 'Are you sure you want to delete the community {name}?',
      confirmDescription: 'This community has {count} members.',
      confirmButton: 'Delete',
      confirmWarning: 'I understand that this action is irreversible',
    },
    addMember: {
      success: 'Member added',
      button: 'Add member',
      noInviteButton: 'Add member without invite',
      noInviteHover:
        'Adds a member directly without inviting, use only in inactive communities to gather data',
      modalTitle: 'Add a member to {name} community',
      modalDescription: 'Select an organisation to add to the {name} community:',
      error: 'Failed to add member',
      cancel: 'Cancel',
    },
    addMemberInvite: {
      success: 'Member invited',
      button: 'Invite member',
      error: 'Failed to invite member',
      cancel: 'Cancel',
    },
    removeMember: {
      success: 'Member removed',
      button: 'Remove member',
      confirmTitle: 'Removing {orgName} from {communityName}',
      confirmDescription:
        'Are you sure you want to remove {orgName} from {communityName} community?',
      error: 'Failed to remove member',
    },
    eventForm: {
      add: 'Add event',
      edit: 'Edit event',
      name: 'Event name',
      namePlaceholder: 'e.g. webinar on digital transformation',
      icon: 'Event icon',
      datetime: 'Event date and time',
      location: 'Event location',
      locationPlaceholder: 'e.g. Risk Ledger offices, london, UK',
      url: 'Event URL',
      urlPlaceholder: 'e.g. eventbrite url',
      addSuccess: 'Event {name} created',
      editSuccess: 'Event {name} updated',
      error: 'Failed to save event',
    },
    deleteEvent: {
      confirmTitle: 'Deleting event {name}',
      confirmDescription:
        'Are you sure you want to delete the event {name} form the community {communityName}?',
      button: 'Delete event',
      success: 'Event deleted',
      error: 'Failed to delete event',
    },
    config: {
      update: 'Update community config',
      updateSuccess: 'SUCCESS',
      error: 'Failed to update config',
      mutualSuppliers: 'Mutual suppliers',
      signals: 'Signals',
      supplierPosts: 'Supplier posts',
      supplierActivityFeed: 'Supplier activity feed',
      networkVisualisation: 'Network visualisation',
      lastModified: 'Last changed',
    },
  },
};
